import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const ExportReportModal = ({ isOpen, onClose }) => {
  const [reportType, setReportType] = useState('');
  const [format, setFormat] = useState('');
  const [dateRange, setDateRange] = useState('');
  const [includeCharts, setIncludeCharts] = useState(true);
  const [includeRawData, setIncludeRawData] = useState(false);

  if (!isOpen) return null;

  const reportTypes = [
    { value: 'financial', label: 'Financial Summary' },
    { value: 'compliance', label: 'Compliance Report' },
    { value: 'maintenance', label: 'Maintenance Analysis' },
    { value: 'occupancy', label: 'Occupancy Report' },
    { value: 'contractor', label: 'Contractor Performance' },
    { value: 'comprehensive', label: 'Comprehensive Report' },
  ];

  const formats = [
    { value: 'pdf', label: 'PDF Document' },
    { value: 'excel', label: 'Excel Spreadsheet' },
    { value: 'csv', label: 'CSV File' },
  ];

  const dateRanges = [
    { value: 'current-month', label: 'Current Month' },
    { value: 'last-month', label: 'Last Month' },
    { value: 'last-3-months', label: 'Last 3 Months' },
    { value: 'last-6-months', label: 'Last 6 Months' },
    { value: 'current-year', label: 'Current Year' },
    { value: 'custom', label: 'Custom Range' },
  ];

  const handleExport = () => {
    console.log('Exporting report:', { reportType, format, dateRange, includeCharts, includeRawData });
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e?.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold text-foreground font-heading">Export Report</h2>
          <button
            onClick={onClose}
            className="h-10 w-10 rounded-lg bg-input border border-border flex items-center justify-center transition-smooth hover:bg-muted"
            aria-label="Close"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="space-y-4">
          <Select
            label="Report Type"
            options={reportTypes}
            placeholder="Select report type"
            value={reportType}
            onChange={setReportType}
            required
          />

          <Select
            label="Export Format"
            options={formats}
            placeholder="Select format"
            value={format}
            onChange={setFormat}
            required
          />

          <Select
            label="Date Range"
            options={dateRanges}
            placeholder="Select date range"
            value={dateRange}
            onChange={setDateRange}
            required
          />

          <div className="space-y-3 pt-4 border-t border-border">
            <p className="text-sm font-medium text-foreground font-caption">Export Options</p>
            
            <Checkbox
              label="Include Charts and Graphs"
              description="Visual representations will be included in the report"
              checked={includeCharts}
              onChange={(e) => setIncludeCharts(e?.target?.checked)}
            />

            <Checkbox
              label="Include Raw Data Tables"
              description="Detailed data tables will be appended to the report"
              checked={includeRawData}
              onChange={(e) => setIncludeRawData(e?.target?.checked)}
            />
          </div>
        </div>

        <div className="flex gap-3 mt-6 pt-6 border-t border-border">
          <Button
            variant="outline"
            fullWidth
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="default"
            fullWidth
            iconName="Download"
            iconPosition="left"
            onClick={handleExport}
            disabled={!reportType || !format || !dateRange}
          >
            Export Report
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExportReportModal;